// extracted by mini-css-extract-plugin
export default {"questions":"yy2HxH4P1VgwJeLe","saveButton":"kzHJFKaYP69fjTAI","updateButton":"ey8i2guuWp1RWqao","cancel":"XyKGzW2khyByYWKQ","info":"oJfqrTJlEMfc1p6T","addNewPoll":"hvPVXHfpnFO3xtq1"};